import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const GroupTransactionRecordsRouter = {
  path: '/group_transaction_records',
  component: Management,
  redirect: '/group_transaction_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      redirect: 'list/all',
      component: () => import('@/views/transaction_records/List'),
      meta: {
        auth: Auth.listGroupTransactionRecords
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/transaction_records/ListTable'),
          meta: {
            auth: Auth.listGroupTransactionRecords,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}

export default GroupTransactionRecordsRouter
